// extracted by mini-css-extract-plugin
export default {"flexContainer":"FooterComp_flexContainer__B3Mov"};